/**
 * A generic dropdown component.  It takes the children of the component
 * and hosts it in the component.  When the component is selected, it
 * drops-down the contentComponent and applies the contentProps.
 */
import React, { useEffect, useRef, useState } from 'react';
import { useDidUpdateEffect } from '../hooks/UseDidUpdateEfect';
import { useKey } from '../hooks/UseKey';
import { useMultiSelect } from '../hooks/UseMultiSelect';
import { KEY } from '../lib/constants';
import SelectPanel from '../select-panel';
import { Cross } from '../select-panel/Cross';
import { Arrow } from './Arrow';
import { DropdownHeader } from './DropdownHeader';
import { Loading } from './Loading';
var Dropdown = function () {
    var _a = useMultiSelect(), t = _a.t, onMenuToggle = _a.onMenuToggle, ArrowRenderer = _a.ArrowRenderer, shouldToggleOnHover = _a.shouldToggleOnHover, isLoading = _a.isLoading, disabled = _a.disabled, onChange = _a.onChange, labelledBy = _a.labelledBy, value = _a.value, isOpen = _a.isOpen, defaultIsOpen = _a.defaultIsOpen, ClearSelectedIcon = _a.ClearSelectedIcon;
    var _b = useState(true), isInternalExpand = _b[0], setIsInternalExpand = _b[1];
    var _c = useState(defaultIsOpen), expanded = _c[0], setExpanded = _c[1];
    var _d = useState(false), hasFocus = _d[0], setHasFocus = _d[1];
    var FinalArrow = ArrowRenderer || Arrow;
    var wrapper = useRef();
    useDidUpdateEffect(function () {
        if (onMenuToggle) {
            onMenuToggle(expanded);
        }
    }, [expanded]);
    useEffect(function () {
        if (defaultIsOpen === undefined && typeof isOpen === 'boolean') {
            setIsInternalExpand(false);
            setExpanded(isOpen);
        }
    }, [isOpen]);
    var handleKeyDown = function (e) {
        var _a;
        // allows space and enter when focused on input/button
        if (['text', 'button'].includes(e.target.type) &&
            [KEY.SPACE, KEY.ENTER].includes(e.code)) {
            return;
        }
        if (isInternalExpand) {
            if (e.code === KEY.ESCAPE) {
                setExpanded(false);
                (_a = wrapper === null || wrapper === void 0 ? void 0 : wrapper.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                setExpanded(true);
            }
        }
        e.preventDefault();
    };
    useKey([KEY.ENTER, KEY.ARROW_DOWN, KEY.SPACE, KEY.ESCAPE], handleKeyDown, {
        target: wrapper,
    });
    var handleHover = function (iexpanded) {
        if (isInternalExpand && shouldToggleOnHover) {
            setExpanded(iexpanded);
        }
    };
    var handleFocus = function () { return !hasFocus && setHasFocus(true); };
    var handleBlur = function (e) {
        if (!e.currentTarget.contains(e.relatedTarget) && isInternalExpand) {
            setHasFocus(false);
            setExpanded(false);
        }
    };
    var handleMouseEnter = function () { return handleHover(true); };
    var handleMouseLeave = function () { return handleHover(false); };
    var toggleExpanded = function () {
        if (isInternalExpand) {
            setExpanded(isLoading || disabled ? false : !expanded);
        }
    };
    var handleClearSelected = function (e) {
        e.stopPropagation();
        onChange([]);
        if (isInternalExpand) {
            setExpanded(false);
        }
    };
    return (React.createElement("div", { tabIndex: 0, className: "dropdown-container", "aria-labelledby": labelledBy, "aria-expanded": expanded, "aria-readonly": true, "aria-disabled": disabled, ref: wrapper, onFocus: handleFocus, onBlur: handleBlur, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        React.createElement("div", { className: "dropdown-heading", onClick: toggleExpanded },
            React.createElement("div", { className: "dropdown-heading-value" },
                React.createElement(DropdownHeader, null)),
            isLoading && React.createElement(Loading, null),
            value.length > 0 && (React.createElement("button", { type: "button", className: "clear-selected-button", onClick: handleClearSelected, disabled: disabled, "aria-label": t('clearSelected') }, ClearSelectedIcon || React.createElement(Cross, null))),
            React.createElement(FinalArrow, { expanded: expanded })),
        expanded && (React.createElement("div", { className: "dropdown-content" },
            React.createElement("div", { className: "panel-content" },
                React.createElement(SelectPanel, null))))));
};
export default Dropdown;



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/multi-select/Dropdown.tsx
// module id = 497
// module chunks = 0